import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/ASH102mid21.pdf'
import cse from '../assets/ASH102end21.pdf'

export default function M_1() {
  return (
    <div>
       <Subject title="Mathematics-1(ASH102)" mid="Q. Paper"
    book1="G.B. Thomas and R.L. Finney, Calculus and Analytic geometry, 9thEdition, Pearson,Reprint "
    book2="Reprint, 2002.Erwin Kreyszig, Advanced Engineering Mathematics, 9thEdition, John Wiley & Sons "
    book1Link="http://www.sufwan.com/wp-content/uploads/CalculusAndAnalyticalGeometry/Calculus-Book-Thomas-Finney.pdf" 
    book2Link=" https://physicaeducator.files.wordpress.com/2017/11/erwin_kreyszig-_advanced_engineering_mathematics.pdf" 
    int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}